export const PRODUCT_PILLARS = [
  {
    id: 'drafts',
    num: '01',
    title: 'AI drafts every document',
    body: 'Statutory reports, creditor circulars, decision procedure notices and chasers, all drafted from case context in seconds. Locked statutory wording is separated from the AI drafted variable sections, so compliance is never at risk',
  },
  {
    id: 'audit',
    num: '02',
    title: 'Audit trail is native',
    body: 'Every action, draft, approval and sign off is recorded with who, what, when and where. Evidence packs export for IPA inspection or court. No reconstruction required',
  },
  {
    id: 'workflow',
    num: '03',
    title: 'Workflows are unified',
    body: 'Around 80% of the work is the same across CVL, Compulsory, Admin, Bankruptcy, IVA and CVA. Asset Hound automates that shared core and overlays the case type specifics. One workflow, six case types',
  },
  {
    id: 'human',
    num: '04',
    title: 'Practitioner stays in control',
    body: 'AI assists; the licensed IP decides. Every AI output is clearly labelled and requires explicit approval before it leaves the system. The platform is an advisor, not the decision maker',
  },
  {
    id: 'assets',
    num: '05',
    title: 'Built for asset recovery, not just admin',
    body: 'Risk analysis at case inception flags the cases that won’t pay before they consume firm time. Asset class intelligence layers in valuation and recoverability signals (Phase 3+)',
  },
  {
    id: 'intelligence',
    num: '06',
    title: 'Trained on case history',
    body: 'AI is grounded in the Insolvency Act 1986, the Insolvency Rules 2016 and each firm’s own historical cases, review standards and unique methodology. As the platform learns from approved outcomes, it surfaces precedent, flags risk and suggests the next move with context the practitioner can trust',
  },
] as const;

export type ProductPillar = (typeof PRODUCT_PILLARS)[number];
